/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React from 'react';

/**
 * Modified MaterialRounded Dashboard Customise.
 * @export
 */
export const CUSTOM_ICON_DASHBOARD_CUSTOMISE = (
  <svg fill="none" height="25" viewBox="0 0 25 25" width="25" xmlns="http://www.w3.org/2000/svg">
    <path
      clipRule="evenodd"
      d="M3.04883 10.9463V4.94626C3.04883 4.39626 3.49883 3.94626 4.04883 3.94626H10.0488C10.5988 3.94626 11.0488 4.39626 11.0488 4.94626V10.9463C11.0488 11.4963 10.5988 11.9463 10.0488 11.9463H4.04883C3.49883 11.9463 3.04883 11.4963 3.04883 10.9463ZM4.04883 21.9463H10.0488C10.5988 21.9463 11.0488 21.4963 11.0488 20.9463V14.9463C11.0488 14.3963 10.5988 13.9463 10.0488 13.9463H4.04883C3.49883 13.9463 3.04883 14.3963 3.04883 14.9463V20.9463C3.04883 21.4963 3.49883 21.9463 4.04883 21.9463ZM13.0488 14.9463V20.9463C13.0488 21.4963 13.4988 21.9463 14.0488 21.9463H20.0488C20.5988 21.9463 21.0488 21.4963 21.0488 20.9463V14.9463C21.0488 14.3963 20.5988 13.9463 20.0488 13.9463H14.0488C13.4988 13.9463 13.0488 14.3963 13.0488 14.9463Z"
      fill="white"
      fillRule="evenodd"
    />
    <rect fill="white" height="11" rx="1" width="2" x="17" y="1.5" />
    <rect fill="white" height="11" rx="1" transform="rotate(90 23.5 6)" width="2" x="23.5" y="6" />
  </svg>
);
